module.exports = __webpack_public_path__ + "img/banner.cd83bd95.png";